import React from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";
import { formatCurrency } from '../utils/currencyFormatter';

const RecentTransactions = ({ transactions, loading, error }) => {
  const navigate = useNavigate();

  return (
    <div style={{ marginTop: "25px" }}>
      <h5 className="mb-3 d-flex justify-content-between px-2">
        <span>Recent Transactions</span>
        <span
          style={{
            color: "rgba(51,185,119,1)",
            fontSize: "14px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
          onClick={() => navigate("/transactions")}
        >
          See all →
        </span>
      </h5>

      {loading ? (
       <Spinner/>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : transactions.length === 0 ? (
        <div className="text-center text-muted">
          No transactions found. Add your first transaction!
        </div>
      ) : (
        <div className="list-group">
          {transactions.map((transaction, index) => (
            <div
              key={transaction._id || index}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div className="d-flex align-items-center">
                <div>
                  <h6 className="mb-0">{transaction.category}</h6>
                  <small className="text-muted">
                    {new Date(transaction.date).toLocaleDateString()}
                  </small>
                </div>
              </div>
              <span
                className={`fw-bold ${
                  transaction.type === "expense" ? "text-danger" : "text-success"
                }`}
              >
                {transaction.type === "expense"
                  ? `- ${formatCurrency(transaction.amount)}`
                  : `+ ${formatCurrency(transaction.amount)}`}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentTransactions;
